import React, { useContext, useMemo } from "react";
import CartCouponCode from "../cart-coupon-code";
import {
  CustomPropertyKeys,
  TranslationKeys,
} from "../../../infrastructure/const";
import CheckUtils from "../../../utilities/check-utils";
import TranslationsContext from "../../../infrastructure/context/translations/translations-context";
import TranslationManager from "../../../infrastructure/translation-manager";

interface ReferralCodeProps {
  properties: Record<string, any>;
  onUpdate: (value: string) => void;
}

const ReferralCode: React.FC<ReferralCodeProps> = ({
  properties,
  onUpdate,
}) => {
  const translationsContext = useContext(TranslationsContext);
  const translationManager = new TranslationManager(translationsContext);

  const referralCodeValue = useMemo(
    () => properties[CustomPropertyKeys.UK.ReferralCode],
    [properties]
  );

  const referralCodeSelected = useMemo(
    () =>
      !CheckUtils.isNullObject(properties) &&
      !CheckUtils.isNullOrEmptyString(referralCodeValue),
    [properties, referralCodeValue]
  );

  const referralCodeApplied =
    !CheckUtils.isNullObject(properties) &&
    referralCodeSelected &&
    !CheckUtils.isNullOrEmptyString(referralCodeValue);

  return (
    <CartCouponCode
      onValueChange={onUpdate}
      id="referral"
      selected={referralCodeSelected}
      value={referralCodeValue}
      applied={referralCodeApplied}
      label={translationManager.getTranslation(
        TranslationKeys.UK.CART_REFERRALCODE_LABEL
      )}
      placeholder={translationManager.getTranslation(
        TranslationKeys.UK.CART_REFERRALCODE_PLACEHOLDER
      )}
      buttonApplyLabel={translationManager.getTranslation(TranslationKeys.APPLY)}
      buttonCancelLabel={translationManager.getTranslation(TranslationKeys.CANCEL)}
      displayResponseMessage={false}
      responseMessage=""
      isErrorMessage={false}
      isMandatory={false}
    />
  );
};

export default ReferralCode;
